import React, { useState } from 'react';
import Icon from 'components/AppIcon';
import CrimeCard from './CrimeCard';

const CATEGORY_CONFIG = {
  street: {
    label: 'Petty Crimes',
    icon: 'MapPin',
    color: '#10B981',
    description: 'Low-risk street crimes for beginners',
  },
  'white-collar': {
    label: 'White Collar',
    icon: 'Briefcase',
    color: '#3B82F6',
    description: 'Financial and corporate crimes',
  },
  trafficking: {
    label: 'Organized Crime',
    icon: 'Package',
    color: '#F59E0B',
    description: 'Smuggling and extortion operations',
  },
  robbery: {
    label: 'Robbery',
    icon: 'Landmark',
    color: '#EF4444',
    description: 'High-risk heists and robberies',
  },
  financial: {
    label: 'High Stakes',
    icon: 'TrendingUp',
    color: '#8B5CF6',
    description: 'Extreme risk, extreme reward',
  },
};

const CrimeCategory = ({ category, crimes, onExecute, territoryBonus, masteryData }) => {
  const [collapsed, setCollapsed] = useState(false);
  const config = CATEGORY_CONFIG?.[category] || { label: category, icon: 'Grid3X3', color: '#64748B', description: '' };

  const availableCount = crimes?.filter(c => !c?.cooldownRemaining || c?.cooldownRemaining <= 0)?.length;

  return (
    <div className="mb-6">
      {/* Category Header */}
      <button
        onClick={() => setCollapsed(c => !c)}
        className="w-full flex items-center justify-between gap-3 mb-3 p-3 rounded-xl transition-all"
        style={{ background: config?.color + '12', border: `1px solid ${config?.color}30` }}
      >
        <div className="flex items-center gap-3">
          <div className="w-9 h-9 rounded-lg flex items-center justify-center flex-shrink-0"
            style={{ background: config?.color + '20', border: `1px solid ${config?.color}40` }}>
            <Icon name={config?.icon} size={18} color={config?.color} />
          </div>
          <div className="text-left">
            <div className="font-heading text-sm font-bold text-foreground">{config?.label}</div>
            <div className="font-caption text-xs text-muted-foreground">{config?.description}</div>
          </div>
        </div>
        <div className="flex items-center gap-3">
          <div className="flex items-center gap-2">
            <span className="font-caption text-xs px-2 py-0.5 rounded-full"
              style={{ background: config?.color + '20', color: config?.color }}>
              {crimes?.length} crimes
            </span>
            {availableCount > 0 && (
              <span className="font-caption text-xs px-2 py-0.5 rounded-full bg-emerald-500/20 text-emerald-400">
                {availableCount} available
              </span>
            )}
          </div>
          <Icon name={collapsed ? 'ChevronDown' : 'ChevronUp'} size={16} color="var(--color-muted-foreground)" />
        </div>
      </button>

      {/* Crime Cards Grid */}
      {!collapsed && (
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-3">
          {crimes?.map(crime => (
            <div key={crime?.id} style={{ width: '100%', maxWidth: '320px' }}>
              <CrimeCard
                crime={crime}
                onExecute={onExecute}
                territoryBonus={territoryBonus}
                masteryLevel={masteryData?.[crime?.crimeKey]?.mastery_level || 0}
              />
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default CrimeCategory;
